// put this at the top of tpc-mobile-menu.js
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tpc-mobile-menu[aria-hidden="true"]').forEach(n => n.removeAttribute('aria-hidden'));
});
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.tpc-mobile-menu[aria-hidden="true"]').forEach(n => n.removeAttribute('aria-hidden'));
});

(function () {
  // ---- Scrollbar for horizontal carousels ----
  function initTpcScrollbars(root = document) {
    root.querySelectorAll('.tpc-carousel').forEach(carousel => {
      const bar = carousel.nextElementSibling && carousel.nextElementSibling.classList?.contains('tpc-scrollbar')
        ? carousel.nextElementSibling
        : null;
      if (!bar) return;
      if (carousel.dataset.scrollbarInitialized === '1') return;
      carousel.dataset.scrollbarInitialized = '1';

      const thumb = bar.querySelector('.tpc-scrollbar__thumb');
      const update = () => {
        const max = carousel.scrollWidth - carousel.clientWidth;
        const p = max > 0 ? (carousel.scrollLeft / max) * 100 : 0;
        thumb.style.width = p + '%';
      };
      update();
      carousel.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  // ---- Accordion helpers ----
  // ensure the panel has an id so aria-controls works
  function ensureIds(item, trigger, panel) {
    if (!panel.id) panel.id = 'tpc-acc-panel-' + Math.random().toString(36).slice(2, 9);
    if (!trigger.getAttribute('aria-controls')) trigger.setAttribute('aria-controls', panel.id);
  }

  function setAria(trigger, panel, isOpen) {
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true'); // don't use [hidden] - it kills transitions
  }

  // animate height smoothly using max-height
  function animatePanel(panel, open) {
    // clear any inline maxHeight to measure natural height
    panel.style.transition = 'none';
    if (open) {
      panel.style.maxHeight = 'none';
      const target = panel.scrollHeight;
      panel.style.maxHeight = '0px';
      // kick to next frame
      requestAnimationFrame(() => {
        panel.style.transition = ''; // use CSS rule transition
        panel.style.maxHeight = target + 'px';
      });
    } else {
      const current = panel.scrollHeight;
      panel.style.maxHeight = current + 'px';
      // kick to next frame
      requestAnimationFrame(() => {
        panel.style.transition = '';
        panel.style.maxHeight = '0px';
      });
    }
  }

  function closeItem(item) {
    if (!item || !item.classList.contains('is-open')) return;
    const trigger = item.querySelector("[class^='tpc-accordion__trigger']");
    const panel   = item.querySelector('.tpc-accordion__panel');
    if (!trigger || !panel) return;

    setAria(trigger, panel, false);
    animatePanel(panel, false);
    item.classList.remove('is-open');
  }

  function openItem(item) {
    const trigger = item.querySelector("[class^='tpc-accordion__trigger']");
    const panel   = item.querySelector('.tpc-accordion__panel');
    if (!trigger || !panel) return;

    ensureIds(item, trigger, panel);
    item.classList.add('is-open');
    setAria(trigger, panel, true);
    animatePanel(panel, true);
  }

  function toggle(e, trigger) {
    const item = trigger.closest('.tpc-accordion__item');
    const root = trigger.closest('.tpc-accordion');
    if (!item || !root) return;

    const isOpen = item.classList.contains('is-open');

    // close all siblings
    root.querySelectorAll('.tpc-accordion__item.is-open').forEach(closeItem);

    // open clicked if it wasn’t open
    if (!isOpen) openItem(item);
  }

  function initAccordions(root = document) {
    // init state - no hidden, controlled by aria + max-height
    root.querySelectorAll('.tpc-accordion__item').forEach(item => {
      const trigger = item.querySelector("[class^='tpc-accordion__trigger']");
      const panel   = item.querySelector('.tpc-accordion__panel');
      if (!trigger || !panel) return;

      ensureIds(item, trigger, panel);
      trigger.setAttribute('type', 'button');

      const shouldBeOpen = item.classList.contains('is-open') || trigger.getAttribute('aria-expanded') === 'true';
      setAria(trigger, panel, !!shouldBeOpen);

      // prepare initial height for smooth first paint
      if (shouldBeOpen) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    });

    // events - delegate once
    if (!root._tpcAccordionBound) {
      document.addEventListener('click', function (e) {
        const t = e.target.closest("[class^='tpc-accordion__trigger']");
        if (!t) return;
        e.preventDefault();
        toggle(e, t);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const t = e.target.closest("[class^='tpc-accordion__trigger']");
        if (!t) return;
        e.preventDefault();
        toggle(e, t);
      });

      root._tpcAccordionBound = true;
    }

    // keep open panels sized if content inside changes (images, etc.)
    const ro = new ResizeObserver(entries => {
      entries.forEach(entry => {
        const panel = entry.target;
        const item = panel.closest('.tpc-accordion__item');
        if (item?.classList.contains('is-open')) {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
    root.querySelectorAll('.tpc-accordion__panel').forEach(p => ro.observe(p));
  }

  function initAll(root = document) {
    initAccordions(root);
    initTpcScrollbars(root);
  }

  // initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Shopify editor hooks
  document.addEventListener('shopify:section:load', e => {
    const section = e.target || document;
    initAll(section);
  });
  document.addEventListener('shopify:section:select', e => {
    const section = e.target || document;
    initAll(section);
  });
})();
